import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import { Typography } from "@mui/material";

const AdornmentTextWidget = ({
  id,
  label,
  value,
  required,
  rawErrors = [],
  disabled,
  readonly,
  options,
  onChange,
}) => {
  const isRateField = id === "rate";
  const inputType = options.inputType || "text"; // "text" | "number"
  const [error] = useState("");
  const displayError = rawErrors.length > 0 ? rawErrors[0] : error;

  const handleChange = (e) => {
    let val = e.target.value;

    if (options.allowDecimal) {
      // allow digits + optional decimal part
      val = val.replace(/[^0-9.]/g, "");

      // prevent multiple decimals
      const parts = val.split(".");
      if (parts.length > 2) {
        val = parts[0] + "." + parts.slice(1).join("");
      }

      // enforce decimal places if maxDecimalPlaces given
      if (options.maxDecimalPlaces && val.includes(".")) {
        const [intPart, decPart] = val.split(".");
        val = intPart + "." + decPart.slice(0, options.maxDecimalPlaces);
      }
    } else if (inputType === "text" && options.digitsOnly) {
      // digits only
      val = val.replace(/\D/g, "");
    }

    // enforce maxLength if provided
    if (options.maxLength) {
      val = val.slice(0, options.maxLength);
    }

    onChange(val);
  };

  const handleKeyDown = (e) => {
    // Always treat value as a string for safety
    const strVal = String(value ?? "");

    if (options.allowDecimal) {
      // allow digits, one dot, navigation keys, backspace
      if (
        !/[0-9]/.test(e.key) &&
        e.key !== "." &&
        e.key !== "Backspace" &&
        e.key !== "Tab" &&
        e.key !== "ArrowLeft" &&
        e.key !== "ArrowRight" &&
        e.key !== "Delete"
      ) {
        e.preventDefault();
      }

      // prevent more than one "."
      if (e.key === "." && strVal.includes(".")) {
        e.preventDefault();
      }

      // enforce decimal places on typing
      if (
        options.maxDecimalPlaces &&
        strVal.includes(".") &&
        /[0-9]/.test(e.key)
      ) {
        const [, decPart] = strVal.split(".");
        if (decPart?.length >= options.maxDecimalPlaces) {
          e.preventDefault();
        }
      }
    } else if (inputType === "text" && options.digitsOnly) {
      if (
        !/^[0-9]$/.test(e.key) &&
        e.key !== "Backspace" &&
        e.key !== "Tab"
      ) {
        e.preventDefault();
      }
    }
  };

  return (
    <>
    <TextField
      id={id}
      label={label}
      value={value ?? ""}
      required={required}
      disabled={!isRateField && disabled}
      fullWidth
      type="text" // keep text so we control decimals properly
      error={Boolean(displayError)}
      helperText={Boolean(displayError) || ""}
      inputProps={{
        min: options.min,
        max: options.max,
        maxLength: options.maxLength,
        inputMode: options.allowDecimal
          ? "decimal"
          : options.digitsOnly
          ? "numeric"
          : undefined,
      }}
      InputProps={{
        startAdornment: options.adornment ? (
          <InputAdornment position="start">
            {options.adornment}
          </InputAdornment>
        ) : null,
        readOnly: !isRateField && (readonly || disabled),
      }}
      onKeyDown={handleKeyDown}
      onChange={handleChange}
    />
    <Typography variant="caption" sx={{ mt: 1, display: "block" }}>
        *Base Rates are subject to change from time to time upon notice to the Client and/or Responsible Party.
    </Typography>
    </>
  );
};

export default AdornmentTextWidget;
